/* eslint-disable @typescript-eslint/no-explicit-any */
// import { WEI_PER_ETH } from "../utils/Constants";
// import {
//   combinationEquals,
//   xDrawClosedEvent,
//   xTierWinners,
// } from "../web3/Types";
import { USDC } from "./UsdcValue";
import { PrizeFund, RevenueDistribution } from "./LotteryConfig";
import { LotteryConfig } from "./LotteryConfig";
import { Ticket } from "./Ticket";
import { PrizeTierResults } from "./PrizeTierResults";
import { Set } from "./Set";
import {
  IndexerDraw,
  IndexerEntry,
  IndexerTierAllocation,
  IndexerTierResult,
} from "../web3/Types";
import { getTicketPrizes } from "../utils/Utils";
import { Charity } from "./Charity";

export class Draw {
  number: bigint;
  ticket: Ticket;
  date: Date;
  jackpot: USDC;
  entries: number;
  charity?: Charity;
  raised: USDC;
  prizeTiersResults: PrizeTierResults[];
  rollover: boolean;
  lotteryConfig: LotteryConfig;
  totalWinners: number;
  winRatio: number;
  totalPrize: USDC;
  ticketsBought: Ticket[];
  userPrize?: USDC;

  constructor(
    number: bigint,
    ticket: Ticket,
    date: Date,
    jackpot: USDC,
    entries: number,
    charity: Charity | undefined,
    raised: USDC,
    prizeTiers: PrizeTierResults[],
    rollover: boolean,
    lotteryConfig: LotteryConfig,
    totalWinners: number,
    winRatio: number,
    totalPrize: USDC,
    ticketsBought: Ticket[],
    userPrize?: USDC,
  ) {
    this.number = number;
    this.ticket = ticket;
    this.date = date;
    this.jackpot = jackpot;
    this.entries = entries;
    this.charity = charity;
    this.raised = raised;
    this.prizeTiersResults = prizeTiers;
    this.rollover = rollover;
    this.lotteryConfig = lotteryConfig;
    this.totalWinners = totalWinners;
    this.winRatio = winRatio;
    this.totalPrize = totalPrize;
    this.ticketsBought = ticketsBought;
    if (!userPrize) {
      let newUserPrize = 0n;
      for (const iTicket of ticketsBought) {
        const prize = getTicketPrizes(iTicket, ticket, prizeTiers);
        iTicket.addPrize(prize);
        newUserPrize += prize.value;
      }
      this.userPrize = new USDC(newUserPrize);
    } else {
      this.userPrize = userPrize;
    }
  }

  setUserPrize(userPrize: USDC) {
    this.userPrize = userPrize;
  }

  static fromGraph(drawData: IndexerDraw): Draw {
    const tickets: Ticket[] = [];
    let userPrize: bigint | undefined = undefined;
    let entry: IndexerEntry | undefined = undefined;
    const winningTicket = new Ticket(
      drawData.ticket_mainNumbers.map((num: any) => BigInt(num)),
      drawData.ticket_luckyStars.map((star: any) => BigInt(star)),
    );
    if (drawData.entries != undefined) {
      if (drawData.entries.length > 0) {
        entry = drawData.entries[0];
      }
      if (entry) {
        userPrize = 0n;
        for (const iTicket of entry.tickets) {
          const ticket: Ticket = new Ticket(
            iTicket.mainNumbers.map((num: any) => BigInt(num)),
            iTicket.luckyStars.map((star: any) => BigInt(star)),
          );
          const tierResults: PrizeTierResults[] = drawData.tiersResults.map(
            (tierResult: IndexerTierResult) =>
              PrizeTierResults.fromGraphQL(tierResult),
          );
          const prize = getTicketPrizes(ticket, winningTicket, tierResults);
          ticket.addPrize(prize);
          userPrize += prize.value;
          tickets.push(ticket);
        }
      } else {
        userPrize = undefined;
      }
    }

    return new Draw(
      BigInt(drawData.drawNumber),
      winningTicket,
      new Date(Number(drawData.timestamp) * 1000),
      new USDC(BigInt(drawData.jackpot)),
      Number(drawData.ticketsBought),
      drawData.charity ? Charity.fromGraph(drawData.charity) : undefined,
      new USDC(drawData.proceeds_donations),
      drawData.tiersResults
        .map(
          (res: any) =>
            new PrizeTierResults(
              Number(res.index),
              new Set(Number(res.tier_mainNumber), Number(res.tier_luckyStar)),
              new USDC(BigInt(res.prizePerWinner)),
              new USDC(BigInt(res.prize)),
              BigInt(res.winningTickets),
            ),
        )
        .sort((a: PrizeTierResults, b: PrizeTierResults) => {
          return a.index - b.index;
        }),
      true,
      new LotteryConfig(
        BigInt(drawData.drawConfig_pools_mainNumbers),
        BigInt(drawData.drawConfig_pools_luckyStars),
        BigInt(drawData.drawConfig_jackpotTier_mainNumbers),
        BigInt(drawData.drawConfig_jackpotTier_luckyStars),
        drawData.drawConfig_tierAllocations
          .map(
            (prizeFund: IndexerTierAllocation) =>
              new PrizeFund(
                Number(prizeFund.tier_mainNumber),
                Number(prizeFund.tier_luckyStar),
                Number(prizeFund.cut),
              ),
          )
          .sort((a: PrizeFund, b: PrizeFund) => {
            if (a.numberAmount !== b.numberAmount) {
              return b.numberAmount - a.numberAmount;
            }
            return b.starAmount - a.starAmount;
          }),
        new RevenueDistribution(
          BigInt(drawData.drawConfig_proceedsAllocation_donations),
          BigInt(drawData.drawConfig_proceedsAllocation_prizes),
        ),
        BigInt(drawData.drawConfig_ticketPrice),
        BigInt(drawData.drawConfig_ticketTotalLimit),
        BigInt(drawData.drawConfig_ticketBuyLimit),
      ),
      Number(drawData.winningTickets),
      Number(drawData.winningTickets) / Number(drawData.ticketsBought),
      new USDC(BigInt(drawData.proceeds_prizes)),
      tickets,
      tickets.length == 0 || userPrize == undefined
        ? undefined
        : new USDC(userPrize),
    );
  }
}
